import { UserResource as LegacyUserResource } from '../../../models'
import { getEnumKeyByEnumValue } from '../../helpers/enum'
import { UserStatus } from '../../types/userStatus'
import { Department } from '../Department/Department'
import { Person } from '../Person/Person'
import { Role } from '../Role/Role'
import {
    EditUserProfileRequest, User, UserFormData, UserResource,
} from './User'

export const transformUserToUserFormData = (user: User): UserFormData => ({
    affix: user.person.affix || '',
    birthday: user.birthday,
    email: user.email,
    employeeNumber: user.employeeNumber,
    firstname: user.person.firstname,
    lastname: user.person.lastname,
    phone: user.phone,
    password: '',
    passwordRepeat: '',
    pincode: '',
    pincodeRepeat: '',
})

export const transformUserFormDataToEditUserProfileRequest = (formData: UserFormData, id: string): EditUserProfileRequest => ({
    type: 'users',
    id,
    attributes: {
        phone: formData.phone,
        pincode: formData.pincode,
        password: formData.password,
    },
})

export const transformToUser = (
    resource: UserResource,
    person: Person,
    departments: Department[],
    roles: Role[],
): User => {
    const status = getEnumKeyByEnumValue(UserStatus, resource.attributes.status)

    if (! status) {
        console.error(`[transformToUser]: Unknown status enum found named "${resource.attributes.status}".`)
    }

    return {
        id: resource.id,
        birthday: new Date(resource.attributes.birthday),
        employeeNumber: resource.attributes.employeeNumber,
        phone: resource.attributes.phone,
        email: resource.attributes.email,
        nationality: resource.attributes.nationality,
        status: status ? UserStatus[status] : UserStatus.active,
        shouldTrackTime: resource.attributes.shouldTrackTime,
        isPaidBasedOnTrackedTime: resource.attributes.isPaidBasedOnTrackedTime,
        isEligibleForTimeForTime: resource.attributes.isEligibleForTimeForTime,
        contractHours: resource.attributes.contractHours,
        registrationComplete: resource.attributes.registrationComplete,
        isLoketAuthorized: resource.attributes.isLoketAuthorized,
        departments,
        roles,
        person,
    }
}

export const transformLegacyUserToUser = (legacyUserResource: LegacyUserResource): UserResource => ({
    id: legacyUserResource.id,
    type: 'users',
    attributes: {
        firstname: legacyUserResource.firstname,
        affix: legacyUserResource.affix || undefined,
        lastname: legacyUserResource.lastname,
        employeeNumber: legacyUserResource.employeeNumber,
        phone: legacyUserResource.phone,
        email: legacyUserResource.email,
        status: legacyUserResource.status,
        shouldTrackTime: legacyUserResource.shouldTrackTime,
        isPaidBasedOnTrackedTime: legacyUserResource.isPaidBasedOnTrackedTime,
        isEligibleForTimeForTime: legacyUserResource.isEligibleForTimeForTime,
        registrationComplete: legacyUserResource.registrationComplete,
        isLoketAuthorized: legacyUserResource.isLoketAuthorized,
        loketEmployeeId: legacyUserResource.loketEmployeeId,
        birthday: legacyUserResource.birthday,
        nationality: legacyUserResource.nationality,
        contractHours: legacyUserResource.contractHours,
    },
})

